//messages.js
export default {
    api_keys_id: "API Keys Id",
    company_id: "Company Id",
    api_key: "API Key",
    corporate_id: "Corporate Id",
    level: "Level",
    user_id: "User Id",
    api_key: "API Key",
    ignore_limits: "Ignore Limits",
    api_secret: "API Secret",
    is_private_key: "Is Private Key",
    ip_addresses: "IP Addresses",
    max_requests_per_hour: "Max Requests Per Hour",
    max_requests_per_minute: "Max Requests Per Minute",
    max_requests: "Max Requests",
    level: "Level",
    app_name: "App Name",
    ignore_limits: "Ignore Limits",
    is_private_key: "Is Private Key",
    ip_addresses: "IP Addresses",
    app_name: "App Name",
    disabled: "Disabled",
    edit_api_key: "Edit API Key",
    add_api_key: "Add API Key",
    delete_api_key: "Delete API Key",
    api_keys: "API Keys",
    delete_api_key_confirm: "This action is not reversible!",
    application: "Application",
    ip_restrictions: "IP Restrictions",
    no_ip_restrictions: "No IP Restrictions",
    api_key_history: "API Key History",
    run_time: "Run Time",
    ip: "IP",
    api_key_history_params: "API Key History Params",
    show_content: "Show Content",
    hide_content: "Hide Content",
    regenerate_key: "Regenerate Key",
};
